import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule  } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'ngx-app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  _changePassForm: FormGroup;

  clicked: boolean = false;
  isAuthenticating: boolean = false;
  baseUrl: string = 'account';
  userId: number = 0;
  email: string = '';
  constructor(private api: ApiService, private router: Router, private route: ActivatedRoute) {
    this._changePassForm = new FormGroup({
      Email: new FormControl(null, [Validators.required]),
      OldPassword: new FormControl(null, [Validators.required]),
      NewPassword: new FormControl(null, [Validators.required]),
      ConfirmPassword: new FormControl(null, [Validators.required])
    });
  }
  ngOnInit() {

    this.route.queryParams.subscribe((params) => {
      let email = params['email'];
      if(email) this.email = email;

    });
  }
  changePassword(){
    this.clicked = true;
    if(!this.form.valid) {
      return false;
    }

    this.form.disable();
    this.isAuthenticating = true;
    let payload = Object.assign(this.form.value);
    this.api.post(`${this.baseUrl}/changepassword`, payload).subscribe((res: any) => {
      if (!res) {
        this.form.enable();
        this.isAuthenticating = false;
        return false;
      }
      setTimeout(() => {
          this.router.navigateByUrl('auth/login');
      }, 3000);
    }, (error : any) => {
        this.form.enable();
        this.isAuthenticating = false;
        return false;
    });
  }

  get form() {
    return this._changePassForm;
  }
}